import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  groupBy,
  padStart,
  sortBy,
} from 'lodash';
import moment from 'moment';
import Checkbox from '@material-ui/core/Checkbox';

import {
  formatPrice,
  sortItems,
  toShortDateFormat,
  toStartCase,
  addTagValue,
  decimalFixed,
} from 'helpers/utils';
import {
  injectIntl,
  PrintableTable,
} from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { selectState } from 'redux/selectors';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';

class StoreCardPrint extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    details: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    info: PropTypes.shape({}),
    isFarm: PropTypes.bool,
    isMarketPlace: PropTypes.bool,
    isCatalog: PropTypes.bool,
    isWarehouse: PropTypes.bool,
    printHeaderChecked: PropTypes.arrayOf(PropTypes.bool).isRequired,
    /* eslint-disable-next-line */
    sortOptions: PropTypes.array.isRequired,

    checkUpdated: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    globals: PropTypes.arrayOf(PropTypes.shape({})),
  };

  static defaultProps = {
    details: [],
    info: {},
    isFarm: false,
    isMarketPlace: false,
    isCatalog: false,
    isWarehouse: false,
    globals: [],
  };

  getData = () => {
    const { details, info, sortOptions, isCatalog, isWarehouse, tags } = this.props;

    const data = [];

    if (details) {
      const taggedItems = addTagValue(details, tags);
      const newInfo = groupBy(taggedItems, item => item.productData.category);
      const categories = sortBy(Object.keys(newInfo));
      categories.forEach((category) => {
        const groupItemsInfo = newInfo[category];
        const sortedGroupItems = sortItems(groupItemsInfo, sortOptions);

        sortedGroupItems.forEach((groupItemInfo) => {
          if (!groupItemInfo.approved) return;
          groupItemInfo.packrows.forEach((packrow, index) => {
            if (index) {
              data.push({
                category,
                ...groupItemInfo,
                ...packrow,
                hide: [
                  'action',
                  'category',
                  'description',
                  'name',
                  'qty',
                  'subname',
                  'sourcename',
                  'status',
                  'tags',
                  'updatedAt',
                ],
                index,
                id: groupItemInfo.id,
                name: groupItemInfo.productData.name,
                sourcename: info.companyName,
                subname: groupItemInfo.productData.subname,
              });
              return;
            }
            data.push({
              category,
              ...groupItemInfo,
              ...packrow,
              index,
              id: groupItemInfo.id,
              name: groupItemInfo.productData.name,
              sourcename: info.companyName,
              subname: groupItemInfo.productData.subname,
            });
          });
        });
      });
    }

    return sortItems(data, sortOptions, isCatalog, isWarehouse);
  }

  updateCheck = (isChecked, index) => {
    const { checkUpdated } = this.props;
    checkUpdated(isChecked, index);
  }

  render() {
    const {
      formatMessage,
      info,
      isFarm,
      isCatalog,
      isMarketPlace,
      isWarehouse,
      printHeaderChecked,
    } = this.props;

    const { currentUser } = this.context;
    const { profile } = currentUser.account;

    const fields = [
      {
        colSpan: 2,
        label: formatMessage('Category'),
        name: 'category',
        render: data => toStartCase(data.category),
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'name',
      },
      {
        colSpan: 3,
        label: formatMessage('ISN'),
        name: 'subname',
      },
      {
        colSpan: 2,
        label: formatMessage('Info'),
        name: 'description',
      },
      {
        colSpan: 3,
        label: formatMessage('Tags'),
        name: 'tags',
        render: data => data.tags.join(', '),
      }
    ];

    if (isCatalog) {
      fields.push(
        {
          colSpan: 2,
          label: formatMessage('Vendor'),
          name: 'sourcename',
          render: data => data.seller.companyName ? data.seller.companyName : data.sourcename
        }
      );
    }

    fields.push(
      {
        className: 'bold',
        colSpan: 2,
        label: formatMessage('Pack-Out'),
        name: 'uom',
        render: data => `${decimalFixed(data.count)} ${data.uom} ${data.pack}`,
      }
    );

    fields.push({
      label: formatMessage('Qty'),
      name: 'availableQuantity',
      // render: row => (row.isBulk ? parseFloat(row.availableQuantity) :
      //   parseFloat(row.availableQuantity, 10) * row.count).toFixed(2),
      render: row => Math.floor(parseFloat(row.availableQuantity)),
    });
    if (!isFarm && !isMarketPlace && !isWarehouse) {
      fields.push({ label: formatMessage('Cost'),
        className: 'bold',
        name: 'cost',
        render: row => `$${formatPrice(((row.cost * (100 - (row.discount || 0))) / 100))}`,
      });
    }

    fields.push({
      label: formatMessage('Price'),
      className: 'bold',
      name: 'price',
      render: row => `$${formatPrice(row.price)}`,
    });
    // fields.push({
    //   colSpan: 2,
    //   label: formatMessage('Update'),
    //   name: 'updatedAt',
    //   render: data => toShortDateFormat(data.updatedAt),
    // });
    fields.push({
      label: 'SKU',
      name: 'sku',
      render: row => `${row.distributorId ? 'G' : 'S'}-${padStart(row.id, 8, '0')}`,
      colSpan: 3,
    });

    const filteredData = this.getData();
    let { companyName, email } = info;

    if (isWarehouse) {
      companyName = profile.companyName;
    }

    return (
      <div>
        <div className="store-card-print-header">
          <div className="business-name">
            {companyName}
          </div>
          <div className="date">
            <div>{formatMessage('AVAILABILITY LIST:')}</div>
            <div>{moment(new Date()).format('LLLL')}</div>
          </div>
          <div className="email">
            {formatMessage('Email')}: {email}
          </div>
        </div>
        <div className="checked-list">
          {
            fields.map((field, index) => (
              <span key={index}>
                <Checkbox
                  checked={printHeaderChecked[index]}
                  onChange={(e, isInputChecked) => this.updateCheck(isInputChecked, index)}
                />
                {field.label}
              </span>
            ))
          }
        </div>
        <div>
          {
            filteredData.length ? (
              <div>
                <PrintableTable
                  checkedArray={printHeaderChecked}
                  data={filteredData}
                  fields={fields}
                />
                <br />
              </div>
            ) : ''
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'tags')(state, 'tags'),
  ...selectState('options', 'globals')(state, 'globals'),
});

export default compose(
  setDisplayName('StoreCardPrint'),
  connect(
    mapStateToProps,
  ),
  injectIntl,
  immutableToJS,
)(StoreCardPrint);
